var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1200pt",
    height: "1200pt",
    viewBox: "0 0 1200 1200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m60 254.25v109.88c113.11-0.035156 177.63 13.961 214.12 30.75 37.055 17.047 49.641 34.699 68.25 64.875s40.012 74.16 85.5 114c10.508 9.2031 22.277 17.863 35.25 26.25-12.973 8.3867-24.742 17.047-35.25 26.25-45.488 39.84-66.891 83.824-85.5 114s-31.195 47.828-68.25 64.875c-36.496 16.785-101.02 30.777-214.12 30.75v109.88c121.74 0.066406 201.43-13.441 260.25-40.5 59.723-27.473 93.547-71.043 115.88-107.25s36.191-64.082 64.5-88.875c20.641-18.078 58.492-54.75 107.62-54.75h157.88v161.62l373.88-216-373.88-216v160.88c-69.246 0.003906-105.22 0.039062-157.88 0-51.887-0.042969-86.988-35.926-107.62-54-28.305-24.789-42.172-52.668-64.5-88.875s-56.152-79.773-115.88-107.25c-58.816-27.055-138.51-40.566-260.25-40.5z",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.20c790656639e736efbe143f6dc3a857.svg";
export { ForwardRef as ReactComponent };